import FormikInputLabel from "components/disw/FormikInputLabel";
import DropDownBoxDX from "devextreme-react/drop-down-box";
import List from "devextreme-react/list";
import { useFiltersComponentsStyles } from "features/billing-and-metering";
import { useDropDownBoxStyles } from "./DropDownBoxStyle";
import { useInputLabelStyles } from "./InputLabelStyle";

interface DropDownProps<T> {
  dataSource: T[];
  value: T[];
  onValueChanged: (e: { value: T[] }) => void;
  placeholder?: string;
  className?: string;
  dropDownContentClass?: string;
  label: string;
  showClearButton?: boolean;
  width?: string | number;
  displayExpr?: string | ((item: T) => string);
  valueExpr?: string | ((item: T) => string);
  required?: boolean;
  isError?: boolean;
  errorText?: string;
  hintText?: string;
  readOnly?: boolean;
}

export function DropDownBox<T = string>({
  dataSource,
  value,
  onValueChanged,
  placeholder,
  width = "100%",
  displayExpr,
  label,
  required = false,
  isError,
  errorText,
  hintText,
  readOnly = false
}: DropDownProps<T>) {
  const inputLabelClasses = useInputLabelStyles();
  const dropDownBoxClasses = useDropDownBoxStyles();
  const filtersComponentsClasses = useFiltersComponentsStyles();
  return (
    <div className={dropDownBoxClasses.root}>
      <FormikInputLabel
        name={label}
        required={required}
        label={label}
        isError={isError}
        errorMessage={errorText}
        labelClasses={inputLabelClasses}
      />
      <DropDownBoxDX
        dataSource={dataSource}
        value={value}
        displayExpr={displayExpr}
        onValueChanged={e => onValueChanged({ value: e.value })}
        placeholder={placeholder}
        className={
          isError
            ? dropDownBoxClasses.dropDownBoxWithError
            : dropDownBoxClasses.dropDownBox
        }
        width={width}
        dropDownOptions={{
          wrapperAttr: {
            class: filtersComponentsClasses.dropDownContent
          }
        }}
        contentRender={() => (
          <List
            dataSource={dataSource}
            selectionMode="multiple"
            selectedItems={value}
            onSelectionChanged={e =>
              onValueChanged({
                value: e.component.option("selectedItems") ?? []
              })
            }
            showSelectionControls={true}
            displayExpr={displayExpr}
          />
        )}
        readOnly={readOnly}
      />
      {hintText && <div className={inputLabelClasses.hintText}>{hintText}</div>}
    </div>
  );
}
